"use strict";
import { Controller } from "@hotwired/stimulus";
import { screens } from "tailwindcss/defaultTheme";
export default class extends Controller {
  connect() {
    this.prevScroll = window.scrollY;
    this.fixMenuBarContainerMargin();
    this.setupEventListeners();
    this.setupScrollHandler();
  }
  /**
   * Determines if the current screen size matches or is smaller than the specified breakpoint.
   * Uses Tailwind CSS screen breakpoints for responsive behavior.
   *
   * @param {string} key - The Tailwind CSS screen breakpoint key (e.g., 'md', 'lg')
   * @returns {boolean} True if the screen is at or below the specified breakpoint
   */
  isMaxScreenSize(key) {
    return window.matchMedia(`(max-width: ${screens[key]})`).matches;
  }
  /**
   * Dynamically adjusts the top margin of the menu bar container to accommodate
   * the sticky header height. This prevents content from being hidden behind
   * the fixed sticky header.
   *
   * The margin is only applied on mobile devices (screens smaller than 'md' breakpoint)
   * to ensure proper spacing when multiple header elements are present, such as
   * omnipresent banner, admin bar, and offline banner.
   * @returns {void}
   */
  fixMenuBarContainerMargin() {
    const menuBarContainer = document.querySelector("#menu-bar-container");
    const marginTop = this.isMaxScreenSize("md") ? this.element.offsetHeight : 0;
    if (menuBarContainer) {
      menuBarContainer.style.marginTop = `${marginTop}px`;
    }
  }
  /**
   * Sets up event listeners for page navigation and window resize events.
   * Ensures the sticky header behaves correctly after page transitions
   * and when the window is resized.
   * @returns {void}
   */
  setupEventListeners() {
    window.addEventListener("resize", () => {
      this.fixMenuBarContainerMargin();
    });
  }
  /**
   * Sets up the scroll event handler that manages the sticky header visibility
   * based on a scroll direction. Only initializes if the sticky header element exists.
   * @returns {void}
   */
  setupScrollHandler() {
    document.addEventListener("scroll", () => {
      this.handleScroll();
    });
  }
  /**
   * Handles scroll events to show or hide the sticky header based on scroll direction.
   * The header is shown when scrolling up or near the top of the page,
   * and hidden when scrolling down to maximize content visibility.
   *
   * Uses a scroll threshold of 5 pixels to prevent excessive toggling
   * from minor scroll movements.
   * @returns {void}
   */
  handleScroll() {
    var _a;
    this.fixMenuBarContainerMargin();
    const header = (_a = document.getElementById("main-bar")) == null ? void 0 : _a.offsetParent;
    if (header && window.getComputedStyle(this.element).position === "fixed") {
      const currentScroll = window.scrollY;
      const goingDown = this.prevScroll > currentScroll;
      const change = Math.abs(this.prevScroll - currentScroll);
      if (change > 5) {
        if (goingDown || currentScroll < this.element.offsetHeight) {
          this.element.style.top = "0";
        } else {
          this.element.style.top = `-${this.element.offsetHeight}px`;
        }
        this.prevScroll = currentScroll;
      }
    }
  }
}
